import React from 'react';
import type { FC } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import moment from 'moment';
import 'moment/locale/ru';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import {
  jssPreset,
  StylesProvider,
  ThemeProvider,
} from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import GlobalStyles from 'src/components/GlobalStyles';
import ScrollReset from 'src/components/ScrollReset';
import { AuthProvider } from 'src/contexts/JWTAuthContext';
import { createTheme } from 'src/theme';
import routes, { renderRoutes } from 'src/routes';
import { useSelector } from 'src/store';
import LoadingScreen from 'src/components/LoadingScreen';

const ru = 'ru';

moment.locale(ru);

const jss = create({ plugins: [...jssPreset().plugins] });
const history = createBrowserHistory();

const App: FC = () => {
  const theme = createTheme({
    responsiveFontSizes: true,
    theme: 'LIGHT',
  });

  const { isAppReady } = useSelector((store) => store.app);

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider
          utils={MomentUtils}
          libInstance={moment}
          locale={ru}
        >
          <SnackbarProvider
            dense
            maxSnack={3}
          >
            <Router history={history}>
              <AuthProvider>
                <GlobalStyles />
                <ScrollReset />
                {
                  isAppReady
                    ? renderRoutes(routes)
                    : <LoadingScreen />
                }
              </AuthProvider>
            </Router>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default App;
